import { keyBy } from 'lodash';
import Interval from '../../../../../src/component/helpers/IntervalCallApi';
import deceptiveService from '../../../../core/services/Technical/DeceptiveServices';
import reducerRegistry from '../../../helpers/ReducerRegistry';
import userSettingService from './../../../../core/services/Common/UserSettingService';
import {
  getDataFollowKeyByDot,
  getParamFromSortState,
  getQueryParams,
} from './../../../helpers/Common';
import Const from './Const';
import { REDUCER_NAME as WL_REDUCER_NAME } from '../../../market/watchlist/reducer';
import ConstCommon from './../../../common/Const';
import currentState from './../../../helpers/CurrentState';

const REDUCER_NAME = 'DECEPTIVE:';
const FETCH_LIST_DECEPTIVE_DATA = `${REDUCER_NAME}FETCH_LIST_DECEPTIVE_DATA`;
const FETCH_LIST_ABNORMALITY_DATA = `${REDUCER_NAME}FETCH_LIST_ABNORMALITY_DATA`;
const FETCH_LIST_CANCELLED_DATA = `${REDUCER_NAME}FETCH_LIST_CANCELLED_DATA`;
const FETCH_LIST_PRESSING_DATA = `${REDUCER_NAME}FETCH_LIST_PRESSING_DATA`;
const FETCH_LIST_AGGRESSIVE_DATA = `${REDUCER_NAME}FETCH_LIST_AGGRESSIVE_DATA`;
const FETCH_LIST_CLOSING_DATA = `${REDUCER_NAME}FETCH_LIST_CLOSING_DATA`;
const CHANGE_WATCH_LIST = `${REDUCER_NAME}CHANGE_WATCH_LIST`;
const SUBSCRIBE_REALTIME_TICK_OVERVIEW = `${REDUCER_NAME}SUBSCRIBE_REALTIME_TICK_OVERVIEW`;
const SUBSCRIBE_REALTIME_TICK_ABNORMALITY = `${REDUCER_NAME}SUBSCRIBE_REALTIME_TICK_ABNORMALITY`;
const SUBSCRIBE_REALTIME_TICK_CANCELLED = `${REDUCER_NAME}SUBSCRIBE_REALTIME_TICK_CANCELLED`;
const SUBSCRIBE_REALTIME_TICK_PRESSING = `${REDUCER_NAME}SUBSCRIBE_REALTIME_TICK_PRESSING`;
const SUBSCRIBE_REALTIME_TICK_AGGRESSIVE = `${REDUCER_NAME}SUBSCRIBE_REALTIME_TICK_AGGRESSIVE`;
const SUBSCRIBE_REALTIME_TICK_CLOSING = `${REDUCER_NAME}SUBSCRIBE_REALTIME_TICK_CLOSING`;
const FETCH_MY_WATCH_LIST = `${REDUCER_NAME}FETCH_MY_WATCH_LIST`;
const SET_LOADING = `${REDUCER_NAME}SET_LOADING`;
const CHANGE_SIZE_COMPONENT = `${REDUCER_NAME}CHANGE_SIZE_COMPONENT`;

const CHANGE_FILTER_LINE_ONE = `${REDUCER_NAME}CHANGE_FILTER_LINE_ONE`;
const CHANGE_FILTER_LINE_TWO = `${REDUCER_NAME}CHANGE_FILTER_LINE_TWO`;
const CHANGE_FILTER_LINE_THREE = `${REDUCER_NAME}CHANGE_FILTER_LINE_THREE`;
const CHANGE_TAB_DATA = `${REDUCER_NAME}CHANGE_TAB_DATA`;
const INIT_COMPONENT = `${REDUCER_NAME}INIT_COMPONENT`;
const UNMOUNT_COMPONENT = `${REDUCER_NAME}UNMOUNT_COMPONENT`;
const SET_FILTER_DATA = `${REDUCER_NAME}SET_FILTER_DATA`;

const SET_CURRENT_SEARCH = `${REDUCER_NAME}SET_CURRENT_SEARCH`;

const LOAD_MORE_PRESSING = `${REDUCER_NAME}LOAD_MORE_PRESSING`;
const LOAD_MORE_AGGRESSIVE = `${REDUCER_NAME}LOAD_MORE_AGGRESSIVE`;
const LOAD_MORE_CANCELLED = `${REDUCER_NAME}LOAD_MORE_CANCELLED`;
const LOAD_MORE_OVERVIEW = `${REDUCER_NAME}LOAD_MORE_OVERVIEW`;
const LOAD_MORE_ABNORMALITY = `${REDUCER_NAME}LOAD_MORE_ABNORMALITY`;
const LOAD_MORE_CLOSING = `${REDUCER_NAME}LOAD_MORE_CLOSING`;

export {
  REDUCER_NAME,
  reducer as default,
  fetchListDeceptiveData,
  loadMoreAggressive,
  loadMoreOverview,
  changeWatchList,
  subscribeRealtimeTickDeceptive,
  subscribeRealtimeTickAbnormality,
  subscribeRealtimeTickCancelled,
  subscribeRealtimeTickPressing,
  subscribeRealtimeTickAggressive,
  subscribeRealtimeTickClosing,
  fetchMyWatchList,
  fetchDataAbnormality,
  cancelfetchDataAbnormality,
  fetchDataCancelled,
  cancelfetchDataCancelled,
  fetchDataPressing,
  cancelfetchDataPressing,
  fetchDataAggressive,
  cancelfetchDataAggressive,
  fetchDataClosing,
  cancelfetchDataClosing,
  cancelfetchDataOverview,
  changeTabData,
  changeFilterLineOne,
  changeFilterLineTwo,
  changeFilterLineThree,
  setFilterData,
  setCurrentSearch,
  loadMorePressing,
  loadMoreCancelled,
  loadMoreAbnormality,
  loadMoreClosing,
};

function loadMorePressing({
  page,
  pageSize,
  currentAvgVolume,
  orderType,
  proportion,
  sortState,
}) {
  return (dispatch, getState) => {
    dispatch(setLoading(true));
    deceptiveService
      .getDataDeceptivePressing({
        AverageVolume10D: currentAvgVolume,
        OrderType: orderType,
        Proportion: proportion,
        Page: page,
        PageSize: pageSize,
        ...getParamFromSortState(sortState, { rank: 'Rank' }),
        ...getExtraParams(getState),
      })
      .then(res => {
        dispatch({
          type: LOAD_MORE_PRESSING,
          payload: res.items || [],
        });
        dispatch(setLoading(false));
      })
      .catch(err => dispatch(setLoading(false)));
  };
}

function setFilterData(payload) {
  return {
    type: SET_FILTER_DATA,
    payload,
  };
}

function setCurrentSearch(currentSearch) {
  return {
    type: SET_CURRENT_SEARCH,
    payload: currentSearch,
  };
}

function getExtraParams(getState) {
  const watchListId = getState()[REDUCER_NAME].watchListId;
  if (!watchListId) {
    return {
      OrganCode: getState()[REDUCER_NAME].currentSearch.code || '',
    };
  }
  const watchList = getState()[REDUCER_NAME].listWatchListByWatchListId[
    watchListId
  ];

  const comGroupCode =
    watchList.typeCode === 'CompanyGroup' &&
    ['VNINDEX', 'HNXIndex', 'UpcomIndex'].includes(watchList.code)
      ? watchList.code
      : '';

  return {
    OrganCode: getState()[REDUCER_NAME].currentSearch.code || '',
    WatchListType: watchList.typeCode,
    ...(comGroupCode
      ? { ComGroupCode: comGroupCode }
      : { WatchListId: watchListId }),
  };
}

function fetchListDeceptiveData() {
  return (dispatch, globalState) => {
    Interval.fetch(
      'OverviewDeceptive',
      dispatch,
      function() {
        dispatch(setLoading(true));
        return deceptiveService.getDataDeceptiveOverview(
          getExtraParams(globalState),
        );
      },
      function(response) {
        if (response) {
          const listDataDeceptive = response.items || [];
          const totalPage = Math.ceil(response.totalCount / Const.itemPerPage);
          dispatch({
            type: FETCH_LIST_DECEPTIVE_DATA,
            payload: {
              listDataDeceptive,
              totalPage,
            },
          });
          dispatch(setLoading(false));
        }
      },
      Const.overviewDeceptiveInterval,
      err => dispatch(setLoading(false)),
    );
  };
}

function loadMoreOverview({ page }) {
  return (dispatch, getState) => {
    dispatch(setLoading(true));
    deceptiveService
      .getDataDeceptiveOverview({
        Page: page,
        PageSize: Const.itemPerPage,
        ...getExtraParams(getState),
      })
      .then(res => {
        dispatch(setLoading(false));
        dispatch({
          type: LOAD_MORE_OVERVIEW,
          payload: res.items || [],
        });
      })
      .catch(err => dispatch(setLoading(false)));
  };
}

function cancelfetchDataOverview() {
  return () => {
    Interval.cancel('OverviewDeceptive');
  };
}

function fetchDataAbnormality(
  currentType,
  currentAvgVolume,
  currentRate,
  sortState,
) {
  return (dispatch, getState) => {
    Interval.fetch(
      'AbnormalityDeceptive',
      dispatch,
      function() {
        dispatch(setLoading(true));
        return deceptiveService.getDataDeceptiveAbnormality({
          AbnormalityType: currentType,
          AverageVolume10D: currentAvgVolume,
          RateOfUnmatched: currentRate,
          ...getParamFromSortState(sortState, {
            rank: 'Rank',
            volumeCEFLUnmatched: 'VolumeFLUnmatched',
          }),
          ...getExtraParams(getState),
        });
      },
      function(response) {
        if (response) {
          const listDataDeceptiveAbnormality = response.items || [];
          const totalPage = Math.ceil(response.totalCount / Const.itemPerPage);
          dispatch({
            type: FETCH_LIST_ABNORMALITY_DATA,
            payload: {
              listDataDeceptiveAbnormality,
              totalPage,
            },
          });
          dispatch(setLoading(false));
        }
      },
      Const.abnormalityDeceptiveInterval,
      err => dispatch(setLoading(false)),
    );
  };
}

function loadMoreAbnormality({
  page,
  currentType,
  currentAvgVolume,
  currentRate,
  sortState,
}) {
  return (dispatch, getState) => {
    dispatch(setLoading(true));
    deceptiveService
      .getDataDeceptiveAbnormality({
        Page: page,
        PageSize: Const.itemPerPage,
        AbnormalityType: currentType,
        AverageVolume10D: currentAvgVolume,
        RateOfUnmatched: currentRate,
        ...getParamFromSortState(sortState, {
          rank: 'Rank',
          volumeCEFLUnmatched: 'VolumeFLUnmatched',
        }),
        ...getExtraParams(getState),
      })
      .then(res => {
        dispatch(setLoading(false));
        dispatch({
          type: LOAD_MORE_ABNORMALITY,
          payload: res.items || [],
        });
      })
      .catch(err => dispatch(setLoading(false)));
  };
}

function cancelfetchDataAbnormality() {
  return () => {
    Interval.cancel('AbnormalityDeceptive');
  };
}

function fetchDataCancelled(currentAvgVolume, sortState) {
  return (dispatch, getState) => {
    Interval.fetch(
      'CancelledDeceptive',
      dispatch,
      function() {
        dispatch(setLoading(true));
        return deceptiveService.getDataDeceptiveCancelled({
          AverageVolume10D: currentAvgVolume,
          ...getParamFromSortState(sortState, {}),
          ...getExtraParams(getState),
        });
      },
      function(response) {
        if (response) {
          const listDataDeceptiveCancelled = response.items || [];
          const totalPage = Math.ceil(response.totalCount / Const.itemPerPage);
          dispatch({
            type: FETCH_LIST_CANCELLED_DATA,
            payload: {
              listDataDeceptiveCancelled,
              totalPage,
            },
          });
          dispatch(setLoading(false));
        }
      },
      Const.cancelledDeceptiveInterval,
      err => dispatch(setLoading(false)),
    );
  };
}

function loadMoreCancelled({ page, currentAvgVolume, sortState }) {
  return (dispatch, getState) => {
    dispatch(setLoading(true));
    deceptiveService
      .getDataDeceptiveCancelled({
        AverageVolume10D: currentAvgVolume,
        Page: page,
        PageSize: Const.itemPerPage,
        ...getParamFromSortState(sortState, {}),
        ...getExtraParams(getState),
      })
      .then(res => {
        dispatch(setLoading(false));
        dispatch({
          type: LOAD_MORE_CANCELLED,
          payload: res.items || [],
        });
      })
      .catch(err => dispatch(setLoading(false)));
  };
}

function cancelfetchDataCancelled() {
  return () => {
    Interval.cancel('CancelledDeceptive');
  };
}

function fetchDataPressing(currentAvgVolume, orderType, proportion, sortState) {
  return (dispatch, getState) => {
    Interval.fetch(
      'PressingDeceptive',
      dispatch,
      function() {
        dispatch(setLoading(true));
        return deceptiveService.getDataDeceptivePressing({
          AverageVolume10D: currentAvgVolume,
          OrderType: orderType,
          Proportion: proportion,
          ...getParamFromSortState(sortState, { rank: 'Rank' }),
          ...getExtraParams(getState),
          Page: 1,
          PageSize: Const.itemPerPage,
        });
      },
      function(response) {
        if (response) {
          const listDataDeceptivePressing = response.items || [];
          const totalPage = Math.ceil(response.totalCount / Const.itemPerPage);
          dispatch({
            type: FETCH_LIST_PRESSING_DATA,
            payload: {
              listDataDeceptivePressing,
              totalPage,
            },
          });
          dispatch(setLoading(false));
        }
      },
      Const.pressingDeceptiveInterval,
      err => dispatch(setLoading(false)),
    );
  };
}

function cancelfetchDataPressing() {
  return () => {
    Interval.cancel('PressingDeceptive');
  };
}

function fetchDataClosing(currentAvgVolume, exceedingPercentage, sortState) {
  return (dispatch, getState) => {
    Interval.fetch(
      'ClosingDeceptive',
      dispatch,
      function() {
        dispatch(setLoading(true));
        return deceptiveService.getDataDeceptiveClosing({
          AverageVolume10D: currentAvgVolume,
          ExceedingPercentage: exceedingPercentage,
          ...getParamFromSortState(sortState, { rank: 'Rank' }),
          ...getExtraParams(getState),
        });
      },
      function(response) {
        if (response) {
          const listDataDeceptiveClosing = response.items || [];
          const totalPage = Math.ceil(
            response.items.totalCount / Const.itemPerPage,
          );
          dispatch({
            type: FETCH_LIST_CLOSING_DATA,
            payload: {
              listDataDeceptiveClosing,
              totalPage,
            },
          });
          dispatch(setLoading(false));
        }
      },
      Const.closingDeceptiveInterval,
      err => dispatch(setLoading(false)),
    );
  };
}

function loadMoreClosing({
  page,
  sortState,
  currentAvgVolume,
  exceedingPercentage,
}) {
  return (dispatch, getState) => {
    dispatch(setLoading(true));
    deceptiveService
      .getDataDeceptiveClosing({
        Page: page,
        PageSize: Const.itemPerPage,
        AverageVolume10D: currentAvgVolume,
        ExceedingPercentage: exceedingPercentage,
        ...getParamFromSortState(sortState, { rank: 'Rank' }),
        ...getExtraParams(getState),
      })
      .then(res => {
        dispatch(setLoading(false));
        dispatch({
          type: LOAD_MORE_CLOSING,
          payload: res.items || [],
        });
      })
      .catch(err => dispatch(setLoading(false)));
  };
}

function cancelfetchDataClosing() {
  return () => {
    Interval.cancel('ClosingDeceptive');
  };
}

function fetchDataAggressive(
  currentAvgVolume,
  orderType,
  totalVolumeBuSd,
  sortState,
) {
  return (dispatch, getState) => {
    Interval.fetch(
      'AggressiveDeceptive',
      dispatch,
      function() {
        dispatch(setLoading(true));
        return deceptiveService.getDataDeceptiveAggressive({
          AverageVolume10D: currentAvgVolume,
          TotalVolumeBuSd: totalVolumeBuSd,
          OrderType: orderType,
          ...getParamFromSortState(sortState, {
            rank: 'Rank',
            volumeBUSD: 'BuSd',
            totalMatchedVolume: 'TotalMatchVolume',
          }),
          ...getExtraParams(getState),
        });
      },
      function(response) {
        if (response) {
          const listDataDeceptiveAggressive = response.items || [];
          const totalPage = Math.ceil(response.totalCount / Const.itemPerPage);

          dispatch({
            type: FETCH_LIST_AGGRESSIVE_DATA,
            payload: {
              listDataDeceptiveAggressive,
              totalPage,
            },
          });
          dispatch(setLoading(false));
        }
      },
      Const.aggressiveDeceptiveInterval,
      err => dispatch(setLoading(false)),
    );
  };
}

function loadMoreAggressive({
  page,
  currentAvgVolume,
  totalVolumeBuSd,
  orderType,
  sortState,
}) {
  return (dispatch, getState) => {
    dispatch(setLoading(true));
    deceptiveService
      .getDataDeceptiveAggressive({
        Page: page,
        PageSize: Const.itemPerPage,
        AverageVolume10D: currentAvgVolume,
        TotalVolumeBuSd: totalVolumeBuSd,
        OrderType: orderType,
        ...getParamFromSortState(sortState, {
          rank: 'Rank',
          volumeBUSD: 'BuSd',
          totalMatchedVolume: 'TotalMatchVolume',
        }),
        ...getExtraParams(getState),
      })
      .then(response => {
        dispatch(setLoading(false));
        dispatch({
          type: LOAD_MORE_AGGRESSIVE,
          payload: response.items,
        });
      })
      .catch(err => dispatch(setLoading(false)));
  };
}

function cancelfetchDataAggressive() {
  return () => {
    Interval.cancel('AggressiveDeceptive');
  };
}

function changeWatchList(watchListId) {
  return dispatch => {
    dispatch({
      type: CHANGE_WATCH_LIST,
      payload: {
        watchListId,
      },
    });
  };
}

function subscribeRealtimeTickDeceptive(data) {
  return {
    type: SUBSCRIBE_REALTIME_TICK_OVERVIEW,
    payload: {
      data,
    },
  };
}

function subscribeRealtimeTickAbnormality(data) {
  return {
    type: SUBSCRIBE_REALTIME_TICK_ABNORMALITY,
    payload: {
      data,
    },
  };
}

function subscribeRealtimeTickCancelled(data) {
  return {
    type: SUBSCRIBE_REALTIME_TICK_CANCELLED,
    payload: {
      data,
    },
  };
}

function subscribeRealtimeTickPressing(data) {
  return {
    type: SUBSCRIBE_REALTIME_TICK_PRESSING,
    payload: {
      data,
    },
  };
}

function subscribeRealtimeTickAggressive(data) {
  return {
    type: SUBSCRIBE_REALTIME_TICK_AGGRESSIVE,
    payload: {
      data,
    },
  };
}

function subscribeRealtimeTickClosing(data) {
  return {
    type: SUBSCRIBE_REALTIME_TICK_CLOSING,
    payload: {
      data,
    },
  };
}

function fetchMyWatchList() {
  return (dispatch, globalState) => {
    userSettingService.getUserWatchList().then(({ items }) => {
      if (items) {
        const { listCompany, listCustom } = getUserWatchListByTypeCode(items);
        let watchListId = globalState()[WL_REDUCER_NAME].watchListId;
        const listWatchList = [Const.itemAll, ...listCustom, ...listCompany];
        const listWatchListId = listWatchList.map(item =>
          getDataFollowKeyByDot(item, Const.watchList.WATCH_LIST_ID),
        );

        if (!listWatchListId.includes(watchListId) || !watchListId) {
          watchListId =
            globalState()[REDUCER_NAME].watchListId ||
            globalState()[REDUCER_NAME].watchListId === 0
              ? globalState()[REDUCER_NAME].watchListId
              : Const.defaultWatchListId;
        }

        const listWatchListByWatchListId = keyBy(
          listWatchList,
          Const.watchList.WATCH_LIST_ID,
        );
        dispatch({
          type: FETCH_MY_WATCH_LIST,
          payload: {
            listCompany,
            listCustom,
            watchListId,
            listWatchListId,
            listWatchListByWatchListId,
            watchLists: items,
          },
        });
      }
    });
  };
}

function getUserWatchListByTypeCode(listUserWatchList) {
  const result = {
    listCustom: [],
    listCompany: [],
  };
  listUserWatchList.forEach(item => {
    if (item.typeCode === Const.watchListType.CUSTOM) {
      result.listCustom.push(item);
    }
    if (item.typeCode === Const.watchListType.COMPANY_GROUP) {
      result.listCompany.push(item);
    }
  });

  return result;
}

function setLoading(isLoading) {
  return dispatch => {
    dispatch({
      type: SET_LOADING,
      payload: isLoading,
    });
  };
}

function changeFilterLineOne(value) {
  return dispatch => {
    dispatch({
      type: CHANGE_FILTER_LINE_ONE,
      payload: {
        value,
      },
    });
  };
}

function changeFilterLineTwo(value) {
  return dispatch => {
    dispatch({
      type: CHANGE_FILTER_LINE_TWO,
      payload: {
        value,
      },
    });
  };
}

function changeFilterLineThree(value) {
  return dispatch => {
    dispatch({
      type: CHANGE_FILTER_LINE_THREE,
      payload: {
        value,
      },
    });
  };
}

function changeTabData(value) {
  return dispatch => {
    currentState.add(
      ConstCommon.listComponent.TASignals,
      'Deceptive.currentTabData',
      value,
    );
    dispatch({
      type: CHANGE_TAB_DATA,
      payload: {
        value,
      },
    });
  };
}

const defaultFilter = {
  1: {
    watchList: 35,
  },
  2: {
    filterLineOne: 1,
    filterLineTwo: 3,
    filterLineThree: 2,
  },
  3: {
    filterLineOne: 3,
  },
  4: {
    filterLineOne: 1,
    filterLineTwo: 3,
    filterLineThree: 1,
  },
  5: {
    filterLineOne: 3,
    filterLineTwo: 2,
    filterLineThree: 1,
  },
  6: {
    filterLineOne: 1,
    filterLineTwo: 4,
  },
};

const initialState = {
  listDeceptiveDataTicker: [],
  listObjectDeceptiveDataByTicker: {},

  listDeceptiveAbnormalityDataTicker: [],
  listObjectDeceptiveAbnormalityDataByTicker: {},

  listDeceptiveCancelledDataTicker: [],
  listObjectDeceptiveCancelledDataByTicker: {},

  listDeceptivePressingDataTicker: [],
  listObjectDeceptivePressingDataByTicker: {},

  listDeceptiveAggressiveDataTicker: [],
  listObjectDeceptiveAggressiveDataByTicker: {},

  listDeceptiveClosingDataTicker: [],
  listObjectDeceptiveClosingDataByTicker: {},

  listWatchListId: [],
  listWatchListByWatchListId: {
    all: Const.itemAll,
  },
  defaultWatchList: null,
  isLoading: false,
  component: {},
  filterData: defaultFilter,
  watchListId: '',
  currentSearch: {},
  watchList: [],
};

function reducer(globalState = {}, action) {
  switch (action.type) {
    case INIT_COMPONENT:
      const mapTab = {
        Overview: 1,
        CeFlAbnormality: 2,
        Cancelled: 3,
        Pressing: 4,
        Aggressive: 5,
        Closing: 6,
      };
      const tabFromQuery = mapTab[getQueryParams('option')];

      return {
        ...globalState,
        ...initialState,
        currentTabData:
          tabFromQuery ||
          currentState.get(
            ConstCommon.listComponent.TASignals,
            'Deceptive.currentTabData',
          ) ||
          1,
        watchListId: currentState.get(
          ConstCommon.listComponent.TASignals,
          'watchListId',
        ),
      };
    case UNMOUNT_COMPONENT:
      return {};
    case FETCH_LIST_DECEPTIVE_DATA:
      const listObjectDeceptiveDataByTicker = keyBy(
        action.payload.listDataDeceptive,
        'organCode',
      );
      const listDeceptiveDataTicker = action.payload.listDataDeceptive.map(
        item => item.organCode,
      );
      return {
        ...globalState,
        listDeceptiveDataTicker,
        listObjectDeceptiveDataByTicker,
        totalPage: action.payload.totalPage,
      };
    case LOAD_MORE_OVERVIEW:
      const overviewDataById = keyBy(action.payload, 'organCode');
      const overviewIds = action.payload.map(item => item.organCode);
      return {
        ...globalState,
        listDeceptiveDataTicker: globalState.listDeceptiveDataTicker.concat(
          overviewIds,
        ),
        listObjectDeceptiveDataByTicker: {
          ...globalState.listObjectDeceptiveDataByTicker,
          ...overviewDataById,
        },
        totalPage: action.payload.totalPage,
      };
    case FETCH_LIST_ABNORMALITY_DATA:
      const listObjectDeceptiveAbnormalityDataByTicker = keyBy(
        action.payload.listDataDeceptiveAbnormality,
        'organCode',
      );
      const listDeceptiveAbnormalityDataTicker = action.payload.listDataDeceptiveAbnormality.map(
        item => item.organCode,
      );
      return {
        ...globalState,
        listDeceptiveAbnormalityDataTicker,
        listObjectDeceptiveAbnormalityDataByTicker,
        totalPage: action.payload.totalPage,
      };

    case LOAD_MORE_ABNORMALITY:
      const abnormalityDataById = keyBy(action.payload, 'organCode');
      const abnormalityIds = action.payload.map(item => item.organCode);
      return {
        ...globalState,
        listDeceptiveAbnormalityDataTicker: globalState.listDeceptiveAbnormalityDataTicker.concat(
          abnormalityIds,
        ),
        listObjectDeceptiveAbnormalityDataByTicker: {
          ...globalState.listObjectDeceptiveAbnormalityDataByTicker,
          ...abnormalityDataById,
        },
      };
    case FETCH_LIST_CANCELLED_DATA:
      const listObjectDeceptiveCancelledDataByTicker = keyBy(
        action.payload.listDataDeceptiveCancelled,
        'organCode',
      );
      const listDeceptiveCancelledDataTicker = action.payload.listDataDeceptiveCancelled.map(
        item => item.organCode,
      );
      return {
        ...globalState,
        listDeceptiveCancelledDataTicker,
        listObjectDeceptiveCancelledDataByTicker,
        totalPage: action.payload.totalPage,
      };
    case LOAD_MORE_CANCELLED:
      const cancelledDataById = keyBy(action.payload, 'organCode');
      const cancelledIds = action.payload.map(item => item.organCode);
      return {
        ...globalState,
        listDeceptiveCancelledDataTicker: globalState.listDeceptiveCancelledDataTicker.concat(
          cancelledIds,
        ),
        listObjectDeceptiveCancelledDataByTicker: {
          ...globalState.listObjectDeceptiveCancelledDataByTicker,
          ...cancelledDataById,
        },
      };
    case FETCH_LIST_PRESSING_DATA:
      const listObjectDeceptivePressingDataByTicker = keyBy(
        action.payload.listDataDeceptivePressing,
        'organCode',
      );
      const listDeceptivePressingDataTicker = action.payload.listDataDeceptivePressing.map(
        item => item.organCode,
      );
      return {
        ...globalState,
        listDeceptivePressingDataTicker,
        listObjectDeceptivePressingDataByTicker,
        totalPage: action.payload.totalPage,
      };

    case LOAD_MORE_PRESSING:
      const dataByIds = keyBy(action.payload, 'organCode');
      const ids = action.payload.map(item => item.organCode);
      return {
        ...globalState,
        listDeceptivePressingDataTicker: globalState.listDeceptivePressingDataTicker.concat(
          ids,
        ),
        listObjectDeceptivePressingDataByTicker: {
          ...globalState.listObjectDeceptivePressingDataByTicker,
          ...dataByIds,
        },
      };
    case FETCH_LIST_AGGRESSIVE_DATA:
      const listObjectDeceptiveAggressiveDataByTicker = keyBy(
        action.payload.listDataDeceptiveAggressive,
        'organCode',
      );
      const listDeceptiveAggressiveDataTicker = action.payload.listDataDeceptiveAggressive.map(
        item => item.organCode,
      );
      return {
        ...globalState,
        listDeceptiveAggressiveDataTicker,
        listObjectDeceptiveAggressiveDataByTicker,
        totalPage: action.payload.totalPage,
      };
    case LOAD_MORE_AGGRESSIVE:
      const aggressiveDataById = keyBy(action.payload, 'organCode');
      const aggressiveIds = action.payload.map(item => item.organCode);
      return {
        ...globalState,
        listDeceptiveAggressiveDataTicker: globalState.listDeceptiveAggressiveDataTicker.concat(
          aggressiveIds,
        ),
        listObjectDeceptiveAggressiveDataByTicker: {
          ...globalState.listObjectDeceptiveAggressiveDataByTicker,
          ...aggressiveDataById,
        },
      };
    case FETCH_LIST_CLOSING_DATA:
      const listObjectDeceptiveClosingDataByTicker = keyBy(
        action.payload.listDataDeceptiveClosing,
        'organCode',
      );
      const listDeceptiveClosingDataTicker = action.payload.listDataDeceptiveClosing.map(
        item => item.organCode,
      );
      return {
        ...globalState,
        listDeceptiveClosingDataTicker,
        listObjectDeceptiveClosingDataByTicker,
        totalPage: action.payload.totalPage,
      };
    case LOAD_MORE_CLOSING:
      const closingDataById = keyBy(action.payload, 'organCode');
      const closingIds = action.payload.map(item => item.organCode);
      return {
        ...globalState,
        listDeceptiveClosingDataTicker: globalState.listDeceptiveClosingDataTicker.concat(
          closingIds,
        ),
        listObjectDeceptiveClosingDataByTicker: {
          ...globalState.listObjectDeceptiveClosingDataByTicker,
          ...closingDataById,
        },
      };
    case CHANGE_WATCH_LIST:
      const watchListId = action.payload.watchListId;
      currentState.add(
        ConstCommon.listComponent.TASignals,
        'watchListId',
        watchListId,
      );
      return { ...globalState, watchListId };
    case SUBSCRIBE_REALTIME_TICK_OVERVIEW:
      return executeRealtime(
        globalState,
        'listObjectDeceptiveDataByTicker',
        action.payload.data,
      );
    case SUBSCRIBE_REALTIME_TICK_ABNORMALITY:
      return executeRealtime(
        globalState,
        'listObjectDeceptiveAbnormalityDataByTicker',
        action.payload.data,
      );
    case SUBSCRIBE_REALTIME_TICK_CANCELLED:
      return executeRealtime(
        globalState,
        'listObjectDeceptiveCancelledDataByTicker',
        action.payload.data,
      );
    case SUBSCRIBE_REALTIME_TICK_AGGRESSIVE:
      return executeRealtime(
        globalState,
        'listObjectDeceptiveAggressiveDataByTicker',
        action.payload.data,
      );
    case SUBSCRIBE_REALTIME_TICK_PRESSING:
      return executeRealtime(
        globalState,
        'listObjectDeceptivePressingDataByTicker',
        action.payload.data,
      );
    case SUBSCRIBE_REALTIME_TICK_CLOSING:
      return executeRealtime(
        globalState,
        'listObjectDeceptiveClosingDataByTicker',
        action.payload.data,
      );

    case FETCH_MY_WATCH_LIST:
      const {
        listWatchListId,
        listWatchListByWatchListId,
        watchLists,
      } = action.payload;

      return {
        ...globalState,
        listWatchListId,
        watchLists,
        listWatchListByWatchListId,
        watchListId: action.payload.watchListId,
      };

    case SET_LOADING:
      return {
        ...globalState,
        isLoading: action.payload,
      };

    case CHANGE_SIZE_COMPONENT:
      return {
        ...globalState,
        component: action.payload,
      };
    case CHANGE_TAB_DATA:
      return {
        ...globalState,
        currentTabData: action.payload.value,
      };
    case CHANGE_FILTER_LINE_ONE:
      return {
        ...globalState,
        filterData: {
          ...globalState.filterData,
          [globalState.currentTabData]: {
            ...globalState.filterData[globalState.currentTabData],
            filterLineOne: action.payload.value,
          },
        },
      };
    case CHANGE_FILTER_LINE_TWO:
      return {
        ...globalState,
        filterData: {
          ...globalState.filterData,
          [globalState.currentTabData]: {
            ...globalState.filterData[globalState.currentTabData],
            filterLineTwo: action.payload.value,
          },
        },
      };
    case SET_FILTER_DATA:
      return {
        ...globalState,
        filterData: action.payload,
      };
    case CHANGE_FILTER_LINE_THREE:
      return {
        ...globalState,
        filterData: {
          ...globalState.filterData,
          [globalState.currentTabData]: {
            ...globalState.filterData[globalState.currentTabData],
            filterLineThree: action.payload.value,
          },
        },
      };
    case SET_CURRENT_SEARCH:
      return {
        ...globalState,
        currentSearch: action.payload,
      };

    default:
      return globalState;
  }
}

reducerRegistry.register(REDUCER_NAME, reducer);

function executeRealtime(globalState, key, data) {
  const listObjectDeceptiveDataByTickerNew = { ...globalState[key] };

  data.forEach(item => {
    if (listObjectDeceptiveDataByTickerNew[item.organCode]) {
      const tickerItem = {
        ...listObjectDeceptiveDataByTickerNew[item.organCode],
      };

      if (tickerItem) {
        tickerItem.totalMatchedVolume = item.totalMatchVolume;
        tickerItem.totalMatchVolume = item.totalMatchVolume;
        tickerItem.matchPrice = item.matchPrice;
        tickerItem.percentPriceChange = item.percentPriceChange;
        tickerItem.tradingDate = item.tradingDate;
      }
      listObjectDeceptiveDataByTickerNew[item.organCode] = tickerItem;
    }
  });

  return { ...globalState, [key]: listObjectDeceptiveDataByTickerNew };
}
